import React from "react";

/**
 * Small inline badge showing agent name attribution.
 * Only renders when the item doesn't belong to the current agent.
 *
 * Props:
 *   agentName - string
 *   isMine    - boolean (if true, renders nothing)
 */
export default function AgentBadge({ agentName }) {
  if (!agentName) return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        background: "#ede9fe",
        color: "#6d28d9",
        fontSize: 11,
        fontWeight: 600,
        padding: "2px 8px",
        borderRadius: 10,
        whiteSpace: "nowrap",
      }}
    >
      {agentName}
    </span>
  );
}
